import StudentDetail from "../../pages/Attendence/studentDetails";
import addCctv from "../../pages/LiveCctv/addCctv";

export const all_routes = {
  form1: "/user-form",
  user: "/user-page",
  // dashboard routes
  adminDashboard: "/index",
   TeacherDashboard: "/dashboard",
  profile:'/profile',
  center:"/center",
  CenterAdd: "/center/addcenter/:id", 
  setting: "/settings",
  studentAttendence:"/studentAttendence",
  teacherAttendence:"teacherAttendence",
  meailMenu:"/mealMenu",
  wish:"/wish",
  wishAdd:"/wish/Add/:ids",
  invoice:"/invoice",
  liveCctv:"/liveCctv",
  noties:"/noties",
  imageGallery:"/imageGallery",
  videoGallery:"/videoGallery",
  addStudents:"/addStudents/:id",
  addClass:"/addClass/:id",
  editClass:"/editClass/:id",
  allClass:"/allClass",
  allStudens:"/allStudents",
  allTeacher:"/allTeacher",
  addTeacher:"/addTeacher/:id",
  leads:"/leads",
  Assignment:"/Assignment",
  addSubjects:'/Assignment/addSubjects/:id',
  viewSubjects:'/Assignment/view/:id',
  expense : "/expense",
  directMessage:"/directMessage",
  notes: "/notes",
  comingSoon: "/coming-soon",
  sendRecord:"sendRecord",
  recordTemplate:"recordTemplate",
  feeFunds:"feeFunds",
  feePayment:"addFee",
  rolesPermissions:'/accessControl',
  permissions:'/permissions',
  feeSetup:"feeSetup",
  subscription:'/subscriptions',
  addSubscription:'/addSubscription',
  editSubscription:'/editSubscription/:id',
  addCctv:'/Livecctv/addCctv',
  StudentDetail:'/studentAttendence/studentdetail/:id',
  TeacherDetail:'/teacherAttendence/teacherdetail/:id',
 transportAssignVehicle:"/management/transport-assign-vehicle",
  transportVehicle:"/management/transport-vehicle",
  transportVehicleDrivers:"/management/transport-vehicle-drivers",
  transportPickupPoints:"/management/transport-pickup-points",
  transportRoutes:"/management/transport-routes",
  channelList:'/Livecctv/channelList',
  editChannel:'/Livecctv/edit-channel/:id',
  // auth routes routes
  login: "/",
  schoolLogin:'/Admin/login',
  teacherLogin:"/Teacher/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  twoStepVerification: "/two-step-verification",
  success: "/success",
  emailVerification: "/email-verification",
  lockScreen: "/lock-screen",
  resetPassword: "/reset-password",
  resetPasswordSuccess: "/reset-password-success",
  // pages routes
  error404: "/error-404",
  error500: "/error-500",
  layoutDefault: "/layout-default",
  layoutMini: "/layout-mini",
  layoutRtl: "/layout-rtl",
  layoutBox: "/layout-box",
  layoutDark: "/layout-dark",
  // announcements routes
  events: "/announcements/events",
  noticeBoard: "/form",
  noticeBoardTwo: "/business",
  search:"/search",
  notificationScreen:"/notificationScreen"
  ,
  // legal / support (public)
  support: "/support",
  privacyPolicy: "/privacy-policy",
  marketing: "/marketing",
  termsAndConditions: "/terms-and-conditions",
};
